import React from "react";
import { useLocation } from "react-router-dom";

import Navbar from "./components/layout/Navbar";
import RegisterNavbar from "./components/layout/RegisterNavbar";
import DashboardNavbar from "./components/layout/DashboardNavbar";

export default function Layout({ children }) {
  const location = useLocation();
  const path = location.pathname;

  // Detect Jobs module pages
  const isJobsModule = path.startsWith("/jobs") || path === "/settings";

  const isRegisterPage = path === "/jobs/register";
  const isHomePage = path === "/jobs" || path === "/jobs/";
  const isDashboardPage = isJobsModule && !isRegisterPage && !isHomePage;

  return (
    <div className="min-h-screen bg-gray-50 font-sans text-gray-900">
      <style
        dangerouslySetInnerHTML={{
          __html: `
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
            body { font-family: 'Inter', sans-serif; }
          `,
        }}
      />

      {/* Jobs Module Navbar Logic */}
      {isJobsModule ? (
        isDashboardPage ? (
          <DashboardNavbar />
        ) : isRegisterPage ? (
          <RegisterNavbar />
        ) : (
          <Navbar />
        )
      ) : null}

      <main>{children}</main>
    </div>
  );
}
